import { render, staticRenderFns } from "./winbank-form.vue?vue&type=template&id=af32d878&scoped=true"
import script from "./winbank-form.vue?vue&type=script&lang=js"
export * from "./winbank-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af32d878",
  null
  
)

export default component.exports